module.exports = __webpack_public_path__ + "img/healthPro2.cd613814.png";